import React from 'react';
import { useIntl } from 'react-intl';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';

export interface ForecastUpdatedWizardScreenProps {
  onClose: () => void;
}

export const ForecastUpdatedWizardScreen = ({ onClose }: ForecastUpdatedWizardScreenProps) => {
  const intl = useIntl();

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onClose}>
      <WizardFinished
        text={intl.formatMessage({
          id: 'predict.forecasting.changes_saved',
          defaultMessage: 'Changes saved'
        })}
      />
    </WizardScreen>
  );
};
